import * as React from "react"
import { Line } from "react-chartjs-2"
import { injectIntl, InjectedIntlProps } from "react-intl"
import AddDemographyModal, { AddDemographyErrors } from "./add-demography-modal"
import AddWordModal, { AddWordErrors } from "./add-word-modal"
import GoalsCard from "./goals-card"
import InstructionCard from "./instruction-card"
import ServiceCard from "./service-card"
import ViewDemographiesModal from "./view-demographies-modal"
import Card from "../../card"
import { FooterItem, ButtonFooterItem } from "../../card/footer-item"
import ViewGlossaryModal from "../../glossary-modal"
import ViewApprocheModal from "../../approch-modal"
import ViewPolitiqueModal,{PolitiqueModalErrors} from "./politique-modal"
import { CardModalNotOkButton } from "../../modal"
import { LocalAuthority, Loan, Scenario, Ppi, Service } from "../../../model"
import PolitiqueCard from "./politique-card"
import Yearmodification from "./YearModification_card"

class LocalAuthorityDetailComponent
extends React.Component<LocalAuthorityDetailComponentProps & InjectedIntlProps> {
	render() {
		const footerItems: FooterItem[] = this.props.consulted
		? [
			{
				content: "Voir plus",
				disabled: this.props.loadingLocalAuthority,
				title: "Voir plus de démographies",
				onClick: this.props.onClickViewDemographies
			} as ButtonFooterItem
		]
		: [
			{
				content: "Voir plus",
				disabled: this.props.loadingLocalAuthority,
				title: "Voir plus de démographies",
				onClick: this.props.onClickViewDemographies
			} as ButtonFooterItem,
			{
				content: "Ajouter",
				disabled: this.props.loadingLocalAuthority,
				title: "Ajouter une démographie",
				onClick: this.props.onClickAddDemography
			} as ButtonFooterItem
		]

		const loans = this.props.loans
		const localAuthority = this.props.localAuthority 
		const scenarii = this.props.scenarii
		const ppi = this.props.ppi
		const currentYear = this.props.currentYear
		const loadingGoalsCard = this.props.loadingLoans
		|| this.props.loadingLocalAuthority
		|| this.props.loadingPpi
		|| this.props.loadingScenarii


		return <div className="section">
			<div className="columns is-multiline">
				<div className="column is-full is-two-thirds-tablet is-three-quarters-widescreen">
					<div className="columns is-multiline">
						<div className="column is-full is-half-widescreen">
							<Card
							footerItems={footerItems}
							loading={this.props.loadingLocalAuthority}
							title="Population">
								<Line
								data={this.props.demographyData}
								height={200}
								options={this.getDemographyOptions()} />
							</Card>
						</div>

						<div className="column">
							<InstructionCard
							loading={this.props.loadingLocalAuthority}
							localAuthority={localAuthority} />
							<div style={{paddingTop:"20px", visibility:"hidden"}}> 
							<Yearmodification
								year={currentYear}			
								/>
							</div>
						</div>
                        
						<div className="column">
						{localAuthority && localAuthority.politicalApproach &&
							[<PolitiqueCard 
							consulted={this.props.consulted}
							loading={this.props.loadingLocalAuthority}
							localAuthority={localAuthority}
							onClickPolitiqueChanges={this.props.onClickPolitiqueChanges}
							onClickViewPolitique={this.props.onClickViewPolitique}
							/>,
							<br/>]
						}
						</div>
					</div>
				</div>

				<div className="column">
					<ServiceCard
					loading={this.props.loadingServices}
					localAuthority={localAuthority}
					services={this.props.services} />
				</div>
			</div>

			{this.props.showViewDemographiesModal &&
			<ViewDemographiesModal
			consulted={this.props.consulted}
			demographies={localAuthority.demographies}
			localAuthority={localAuthority}
			onClickCloseButton={e => { this.props.onClickViewDemographyModalCloseButton(e) }}
			onClickFooterButton={(b, e) => { this.props.onClickViewDemographyModalFooterButton(b, e) }} />}

			{this.props.showAddDemographyModal &&
			<AddDemographyModal
			errors={this.props.addDemographyErrors}
			maxYear={this.props.currentYear}
			onClickCloseButton={this.props.onClickAddDemographyModalCloseButton}
			onClickFooterButton={this.props.onClickAddDemographyModalFooterButton}
			onSubmit={this.props.onSubmitAddDemographyModal}
			submitting={this.props.addingDemography} />}

			{this.props.PolitiqueChanges &&
			<ViewApprocheModal
			localAuthority={localAuthority}
			onClickCloseButton={this.props.onClickViewApprocheCloseButton}
			onClickFooterButton={this.props.onClickViewApprocheFooterButton}
			/>}

			{this.props.showViewGlossary &&
			<ViewGlossaryModal
			localAuthority={localAuthority}
			onClickCloseButton={this.props.onClickViewGlossaryCloseButton}
			onClickFooterButton={this.props.onClickViewGlossaryFooterButton}
			/>}

			{this.props.showViewPolitique &&
			 <ViewPolitiqueModal 
			 errors={this.props.PolitiqueErrors}
			 onClickCloseButton={this.props.onClickPolitiqueModalButton}
			 onClickFooterButton={this.props.onClickPolitiqueModalFooterButton}
			 onSubmit={this.props.onSubmitPolitiqueModal}
			 submitting={this.props.addingWord}
			/>}

			{this.props.showAddWord &&
			<AddWordModal
			errors={this.props.addWordErrors}
			onClickCloseButton={this.props.onClickAddWordCloseButton}
			onClickFooterButton={this.props.onClickAddWordFooterButton}
			onSubmit={this.props.onSubmitAddWord}
			submitting={this.props.addingWord}
			/>}
		</div>
	}

	private getDemographyOptions(): Chart.ChartOptions {
		const options: Chart.ChartOptions = {
			legend             : { display: false },
			maintainAspectRatio: false,
			scales             : {
				xAxes: [{ offset: true }],
				yAxes: [{
					offset: true,
					ticks : { callback: value => this.props.intl.formatNumber(value) }
				}]
			},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex] as number
					const formattedValue = this.props.intl.formatNumber(value)
					return `${formattedValue} habitant${value > 1 ? "s" : ""}`
				},
				title: (tooltips) => {
					const year = tooltips[0].xLabel
					return `Population en ${year}`
				}
			}}
		}
		return options
	}
}

export default injectIntl(LocalAuthorityDetailComponent)

export interface LocalAuthorityDetailComponentProps {
	addWordErrors: AddWordErrors
	PolitiqueErrors:PolitiqueModalErrors
	consulted: boolean
	showViewPolitique: boolean
	currentYear: number
	demographyData: Chart.ChartData
	loans: Loan[]
	loadingLoans: boolean
	loadingLocalAuthority: boolean
	loadingPpi: boolean
	loadingScenarii: boolean
	loadingServices: boolean
	localAuthority: LocalAuthority
	ppi: Ppi
	scenarii: Scenario[]
	services: Service[]
	showAddDemographyModal: boolean
	showAddWord: boolean
	showViewDemographiesModal: boolean
	showViewGlossary: boolean
	addDemographyErrors?: AddDemographyErrors
	addingDemography?: boolean
	addingWord?: boolean
	PolitiqueChanges:boolean

	onClickAddDemography(event: React.SyntheticEvent<Element>): void
	onClickAddDemographyModalCloseButton(event: React.SyntheticEvent<Element>): void
	onClickAddDemographyModalFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
	onClickAddWord(event: React.SyntheticEvent<Element>): void
	onClickAddWordCloseButton(event: React.SyntheticEvent<Element>): void
	onClickPolitiqueModalButton(event: React.SyntheticEvent<Element>): void
	onClickPolitiqueModalFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onClickAddWordFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onClickViewDemographies(event: React.SyntheticEvent<Element>): void
	onClickViewDemographyModalCloseButton(event: React.SyntheticEvent<Element>): void
	onClickViewDemographyModalFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
	onClickViewGlossary(event: React.SyntheticEvent<Element>): void
	onClickPolitiqueChanges(event: React.SyntheticEvent<Element>): void
	onClickViewGlossaryCloseButton(event: React.SyntheticEvent<Element>): void
	onClickViewApprocheCloseButton(event: React.SyntheticEvent<Element>): void
	onClickViewGlossaryFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onClickViewApprocheFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onSubmitAddDemographyModal(event: React.SyntheticEvent<Element>): void
	onSubmitAddWord(event: React.SyntheticEvent<Element>): void
	onSubmitPolitiqueModal(event: React.SyntheticEvent<Element>): void
	onSubmitEditWord(event: React.SyntheticEvent<Element>): void
	onClickViewPolitique(event: React.SyntheticEvent<Element>): void
	onClickViewPolitiqueClose(event: React.SyntheticEvent<Element>): void
}



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/local-authority-detail-component.tsx